/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./turnstile.component";
var styles_TurnstileComponent = [];
var RenderType_TurnstileComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_TurnstileComponent, data: {} });
export { RenderType_TurnstileComponent as RenderType_TurnstileComponent };
export function View_TurnstileComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["id", "cf-turnstile-container"]], null, null, null, null, null))], null, null); }
export function View_TurnstileComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-turnstile", [], null, null, null, View_TurnstileComponent_0, RenderType_TurnstileComponent)), i0.ɵdid(1, 114688, null, 0, i1.TurnstileComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var TurnstileComponentNgFactory = i0.ɵccf("app-turnstile", i1.TurnstileComponent, View_TurnstileComponent_Host_0, { siteKey: "siteKey" }, { resolved: "resolved" }, []);
export { TurnstileComponentNgFactory as TurnstileComponentNgFactory };
